import styled, { css } from 'styled-components';

export const Container = styled.div`
  ${({ theme }) => css`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.layout.spacing(2)};
    padding: ${theme.layout.spacing(3)};
    text-align: center;

    width: 100%;
    max-height: 90vh;
    overflow: auto;

    border-radius: 16px 16px 0 0;
    background: ${theme.palette.neutral[50]};

    img {
      width: 100px;
    }

    header {
      display: flex;
      flex-direction: column;
      gap: ${theme.layout.spacing(1)};

      h2 {
        font-size: ${theme.typography.sizes.title3};
        font-weight: ${theme.typography.weight.bold};
        color: ${theme.palette.primary.main};
      }

      p {
        font-size: ${theme.typography.sizes.body1};
        font-weight: ${theme.typography.weight.regular};
        color: ${theme.palette.text.light};
      }
    }

    form {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: ${theme.layout.spacing(2)};
    }

    @media (min-width: ${theme.layout.breakpoints.md}) {
      max-width: ${theme.layout.spacing(60)};
      border-radius: 16px;
    }
  `}
`;

export const CloseButton = styled.button`
  ${({ theme }) => css`
    position: absolute;
    top: ${theme.layout.spacing(2)};
    right: ${theme.layout.spacing(2)};

    display: flex;
    border: none;
    background: transparent;
    color: ${theme.palette.text.light};

    svg {
      width: 20px;
      height: 20px;
    }
  `}
`;
